import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "text-sm text-red-600" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'InputError',
    props: {
        message: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("p", _hoisted_1, _toDisplayString(__props.message), 1)
            ], 512)), [
                [_vShow, __props.message]
            ]);
        };
    }
});
